import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ align }) => align};
  line-height: 1.5715;
`;

// @TODO: Renomear o componente para LabelledText?
function LabelValue({
  label,
  value,
  align = 'start',
  valueColor = 'black',
  labelColor = '#656668',
  loading = false,
  fontSizeLabel = '14px',
  fontSizeValue = '16px',
  size = 'medium',
}) {
  let labelSize = fontSizeLabel;
  let valueSize = fontSizeValue;
  if (size === 'small') {
    labelSize = '12px';
    valueSize = '14px';
  }

  if (size === 'large') {
    labelSize = '16px';
    valueSize = '18px';
  }

  if (loading) {
    return <Spin />;
  }

  return (
    <Wrapper align={align}>
      <CustomText
        color={labelColor}
        fontSize={labelSize}
      >
        {label}
      </CustomText>
      <CustomText
        fontSize={valueSize}
        fontWeight="400"
        color={valueColor}
      >
        {value}
      </CustomText>
    </Wrapper>
  );
}

LabelValue.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  align: PropTypes.string,
  valueColor: PropTypes.string,
  labelColor: PropTypes.string,
  loading: PropTypes.bool,
  fontSizeValue: PropTypes.string,
  fontSizeLabel: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

LabelValue.defaultProps = {
  align: 'start',
  valueColor: 'black',
  labelColor: '#656668',
  loading: false,
  fontSizeValue: '16px',
  fontSizeLabel: '14px',
  size: 'medium',
};

export default LabelValue;
